<template>
  <div class="setting_frame fx fdc">
    <Header :title="$tp('header.title.setting')">
      <div class="nav_btn" @click="toPage('edit')"><img src="@img/header/edit.svg"></div>
    </Header>
    <div class="_fill">
      <div class="userInfo">
        <div class="image_box _avatar" :class="{default: !userInfo.imageUrl}">
          <div v-if="userInfo.imageUrl" class="image" :style="{backgroundImage: `url(${userInfo.imageUrl})`}"></div>
        </div>
        <div class="name">{{userInfo.name}}</div>
        <div class="email">{{userInfo.email}}</div>
      </div>
      <div class="block_frame _fill">
        <div class="block_title">設定</div>
        <!-- <div class="block_ctn _btn" @click="toPage('changePassword')">
          <div class="label">修改密碼</div>
          <div class="arrow"><img src="@img/block/arrow.svg"></div>
        </div> -->
        <div class="block_ctn">
          <div class="label">提醒</div>
          <el-switch v-if="isReady" v-model="reminder" @change="editUserMe"></el-switch>
        </div>

        <div class="block_ctn _btn" @click="toPage('deleteAccount')">
          <div class="label">刪除帳號</div>
          <div class="arrow"><img src="@img/block/arrow.svg"></div>
        </div>
      </div>
    </div>
    <div class="wv_button">
      <div class="btn_group">
        <div class="main_btn _main logout" @click="logout">{{$tp("label.logout")}}</div>
      </div>
      <Version />
    </div>

    <router-view />
  </div>
</template>

<script>
//api
import { logout } from "@/api/auth";
import { editUserMe } from "@/api/userMe";
export default {
  data() {
    return {
      isReady: false,
      reminder: true
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      await this.$store.dispatch("GetUserInfo");
      this.reminder = this.userInfo.reminder;
      this.isReady = true;
    },
    toPage(type) {
      switch (type) {
        case "edit": this.$router.push({ path: "/setting/edit" }); break;
        case "changePassword": this.$router.push({ path: "/setting/changePassword" }); break;
        case "deleteAccount": this.$router.push({ path: "/setting/deleteAccount" }); break;
      }
    },
    async editUserMe() {
      try {
        await editUserMe({ reminder: this.reminder });
        this.$store.dispatch("GetUserInfo");
      }
      catch (error) {
        NOTIFICATION("e", error?.message || this.$tp("slot.failed", { label: this.$tp("label.update") }));
        //
        this.reminder = this.userInfo.reminder;
      }
    },
    async logout() {
      try {
        const res = await logout();

        if (res) {
          this.$store.commit("SET_IS_LOGIN", false);
        }
      }
      catch (error) {
        NOTIFICATION("e", error?.message || this.$tp("slot.failed", { label: this.$tp("label.logout") }));
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.setting_frame {
  height: 100%;
  .userInfo {
    padding: 0.8rem 0 1rem;
    text-align: center;
    border-bottom: 1px solid $gray_95;
    .image_box {
      @include image-box(3.4rem);
      margin: 0 auto;
    }
    .name {
      margin-top: 0.4rem;
      font-size: 90%;
      font-weight: 500;
    }
    .email {
      font-size: 70%;
      color: $gray_60;
    }
  }

  .wv_button {
    .btn_group {
      display: flex;

      .main_btn {
        flex: 30%;

        &.logout {
          flex: 70%;
        }

        + .main_btn {
          margin-left: 0.5rem;
        }
      }
    }
  }
}
</style>